import { render, staticRenderFns } from "./query-history.vue?vue&type=template&id=19e61746&scoped=true&"
import script from "./query-history.vue?vue&type=script&lang=js&"
export * from "./query-history.vue?vue&type=script&lang=js&"
import style0 from "./query-history.vue?vue&type=style&index=0&id=19e61746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e61746",
  null
  
)

export default component.exports